import { Component, OnInit, Input } from '@angular/core';
import { User } from '../user/user';
import { UserService } from '../_services';
import { Authenticate } from '../authenticate/authenticate';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AttachmentService } from '../attachment/attachmentservice';
import { Attachment } from '../attachment/attachment';


@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.less', '../app.component.less']
})
export class UserProfileComponent implements OnInit {
  currentUser: User;
  auth: Authenticate;
  uu = environment.appURL;
  constructor(private userService: UserService,
    private sanitizer: DomSanitizer,
    private attachmentservice: AttachmentService) { }
  private formData: FormData;


  //---------------------------------------------------
  //  PAGE LOAD FUNCTION 
  //---------------------------------------------------
  ngOnInit() {
    this.getCurrentUser();
  }

//---------------------------------------------------
//  GET LOGGED IN USER IF ANY
//---------------------------------------------------
  getCurrentUser() {
    try {
      this.auth = null;
      this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
      if (this.auth != null) {
        this.currentUser = this.auth.user;
        return true;
      }
      else {
        this.currentUser = null;
        return false;
      }
    }
    catch (e) {
      console.log("we caught an error!!" + e);
      return false;
    }

  }

  //---------------------------------------------------
  //  AVATAR IMAGE UPLOAD FUNCTION SET 
  //---------------------------------------------------
  onFileChangedOriginal(event) {
    const file = event.target.files[0];
    var reader = new FileReader();
    reader.onload = (event: any) => {
      var im = document.getElementById("AV");
      im.setAttribute('src', event.target.result);
      this.currentUser.img = event.target.result;
    }
    reader.readAsDataURL(event.target.files[0]);
  }

  onFileChanged(event) {
    const thisfile = event.target.files[0];
    this.formData = new FormData();
    this.formData.append('files', thisfile);
    this.formData.append('testvalue', 'my test value');
    this.formData.forEach((value, key) => {
    });
    var reader = new FileReader();
    reader.onload = (event: any) => {
      var im = document.getElementById("AV");
      im.setAttribute('src', event.target.result);
      this.uploadAttachUrl();
    }
    reader.readAsDataURL(event.target.files[0]);
  }

  uploadAttachUrl() {
    this.attachmentservice.addAttachUrl(this.formData).subscribe(response => {
      var attrep = new Attachment;
      attrep.url = response[0].url;
      attrep.mime = response[0].mime;
      attrep.name = response[0].name;
      attrep.size = response[0].size;
      this.currentUser.img = environment.appURL + attrep.url;
    });
  }


//---------------------------------------------------
//  ENABLE / DISABLE EDITABLE INPUT ELEMENTS
//---------------------------------------------------
  toggle() {
    var uname = document.getElementsByTagName('input');
    var i = 0;
    for (i = 0; i < uname.length; i++) {
      if (uname[i].name == "elementusername") {
      }
      else {
        uname[i].removeAttribute('disabled');
      }
    }
  }

//---------------------------------------------------
//  SAVE CHANGES FUNCTION 
//---------------------------------------------------
  save() {

    
try
{
    if(this.currentUser.password.length < 5 )
{
  window.alert("Please make sure your password is longer than 5 characters and try again.")
  return;
}
}
catch{
  var uname = document.getElementsByTagName('input');
  var i = 0;
  for (i = 0; i < uname.length; i++) {
    uname[i].setAttribute('disabled', 'disabled');
  }
}

    var uname = document.getElementsByTagName('input');
    var i = 0;
    for (i = 0; i < uname.length; i++) {
      uname[i].setAttribute('disabled', 'disabled');
    }
    
    this.userService.update(this.currentUser).subscribe(resp => {
    });
  }
}
